module.exports = __webpack_public_path__ + "img/dash-icon.e2ee6994.svg";